import { createApp } from "vue"
import SmiliesetGenerate from '../components/SmiliesetGenerate.vue'
import $ from 'jquery'

const style = `
position: fixed;
background: #2c2c2ccc;
box-shadow: 0px 0px 98px 0px #000000 inset;
top: 0;
left: 0;
right: 0;
bottom: 0;
display: flex;
align-items: center;
justify-content: center;
`

export default class SmilieGenerateTool 
{
    static generateFromLocalDisk() {
        let dom = document.createElement('div')
        dom.id = 'awoods-smilieset-generate'
        dom.setAttribute('style', style)
        dom.addEventListener('click', function(e) {
            if(e.target != this)
                return
            quit()
        })
        let jq = $(dom).appendTo('body')
        let v = createApp(SmiliesetGenerate)
        let m = v.mount('#awoods-smilieset-generate');
        (m as any).onFinish = () => quit()
    
        let quit = () => {
            v.unmount()
            jq.remove()
        }
    };
    
}